export function formatTermsContent(rawContent: string): string {
  if (!rawContent) return "";
  return rawContent
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n");
}
